import { Fragment, useCallback, useState } from 'react';
import Input from '../../../form/Input';

interface PNameProps {
  pRef: React.RefObject<HTMLInputElement>;
  value?: string;
  onChange?: (value: string) => void;
}

/**
 * @author taulmax
 * @date 2024.10.11
 * @description 상품 등록 페이지 - 상품명
 */
const PName = ({ pRef, value: externalValue, onChange: externalOnChange }: PNameProps) => {
  const [internalValue, setInternalValue] = useState<string>('');
  const value = externalValue !== undefined ? externalValue : internalValue;
  
  const onChangePName = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      if (externalOnChange) {
        externalOnChange(newValue);
      } else {
        setInternalValue(newValue);
      }
    },
    [externalOnChange]
  );

  return (
    <Input
      inputRef={pRef}
      value={value}
      onChange={onChangePName}
      textAlign="left"
      placeholder="상품명을 입력하세요"
      style={{ width: '100%' }}
    />
  );
};

export default PName;
